(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["exit-intent-recovery"] && !Shopify.designMode) return;
  try {
    
(() => {
  const TAG = 'gn-exit-offer';
  const KEY = 'glownest_exit_offer_SAVE8';
  if (customElements.get(TAG)) return;

  class GlowNestExitOffer extends HTMLElement {
    connectedCallback() {
      // The editor may insert the same section again; wait for its child markup.
      queueMicrotask(() => { if (this.isConnected && !this.active) this.initialize(); });
    }

    disconnectedCallback() { this.dispose(); }

    initialize() {
      if ([...document.querySelectorAll('gn-exit-offer')].some(node => node !== this && node.active)) return;
      this.dialog = this.querySelector('dialog');
      if (this.dataset.template !== 'storewide' || !this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.claim = this.querySelector('[data-exit-claim]');
      this.code = (this.dataset.code || '').trim();
      if (!this.code || !this.claim) return;
      this.active = true;
      this.shown = false;
      this.pending = false;
      this.started = performance.now();
      this.maxDepth = 0;
      this.lastTouch = -Infinity;
      this.mobile = matchMedia('(hover: none), (pointer: coarse)');
      this.editor = this.dataset.editor === 'true';
      this.controller = new AbortController();
      const on = (node, event, handler, options = {}) => node.addEventListener(event, handler, { ...options, signal: this.controller.signal });
      this.resetGesture();
      this.updateDepth();
      this.updateLink();

      on(this.querySelector('[data-exit-close]'), 'click', () => this.close());
      on(this.querySelector('[data-exit-decline]'), 'click', () => this.close());
      on(this.dialog, 'cancel', event => { event.preventDefault(); this.close(); });
      on(this.dialog, 'close', () => this.restorePage());
      on(this.dialog, 'pointerdown', event => { this.backdropDown = event.target === this.dialog && this.outsidePanel(event); });
      on(this.dialog, 'click', event => {
        if (this.backdropDown && event.target === this.dialog && this.outsidePanel(event)) this.close();
        this.backdropDown = false;
      });
      on(this.dialog, 'keydown', event => {
        if (event.key !== 'Tab') return;
        const items = [...this.dialog.querySelectorAll('button:not([disabled]), a[href]')];
        const first = items[0], last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      on(this.claim, 'pointerdown', () => this.updateLink());
      on(this.claim, 'click', event => {
        if (this.editor) { event.preventDefault(); return; }
        this.updateLink(); // Includes a variant/query changed while the offer was open.
        this.claimed = true;
        try { localStorage.setItem(this.cooldownKey(), String(Date.now())); } catch (_) {}
        try {
          const previous = this.readClaim();
          const at = previous && previous.code === this.code && Number.isFinite(previous.at) && previous.at <= Date.now() ? previous.at : Date.now();
          this.writeClaim({ code: this.code, at, dismissed: false });
        } catch (_) { /* Native discount link still works. */ }
        this.claim.querySelector('span').textContent = 'Applying your offer…';
        this.claim.setAttribute('aria-busy', 'true');
      });
      on(document, 'shopify:section:unload', event => { if (event.target.contains(this)) this.dispose(); });
      on(window, 'pagehide', () => { this.pauseReading(); if (this.intent && this.intent.checkout && this.checkoutArmed && this.checkoutEvent && !this.checkoutEvent.defaultPrevented && Date.now() - this.intent.checkout.at < 10000) this.intent.checkout.left = true; this.saveIntent(); this.close(); });
      on(window, 'pageshow', event => { this.resetGesture(); if (event.persisted) { this.resumeReading(); this.scheduleSavings(); this.checkCheckoutReturn(); } });
      on(document, 'visibilitychange', () => { this.lastTouch = -Infinity; this.resetGesture(); if (document.hidden) this.pauseReading(); else this.resumeReading(); });
      on(window, 'resize', () => { this.lastTouch = -Infinity; this.resetGesture(); }, { passive: true });

      if (this.editor) {
        if (this.dataset.preview === 'true') this.show(true);
        return;
      }
      this.initializeIntent(on);
      this.initializeFeedback(on);
      this.initializeHeaderOffer(on);
      on(document.documentElement, 'mouseleave', event => {
        if (!this.mobile.matches && event.relatedTarget === null && event.clientY <= 0) this.requestShow('desktop-exit');
      });
      on(window, 'scroll', () => this.onScroll(), { passive: true });
      const touch = event => this.onTouch(event);
      on(document, 'touchstart', touch, { passive: true });
      on(document, 'touchmove', touch, { passive: true });
      on(document, 'touchend', touch, { passive: true });
      on(document, 'touchcancel', touch, { passive: true });
      on(window, 'wheel', event => { if (!this.mobile.matches && event.deltaY < 0) this.lastTouch = performance.now(); }, { passive: true });
    }

    initializeHeaderOffer(on) {
      // Liquid already restricts this section to SSS / 1-x-d. Cart pages keep their header.
      if (this.dataset.context !== 'product' || this.dataset.headerOffer !== 'true') return;
      on(window, 'click', event => {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
        const target = event.target instanceof Element ? event.target : null;
        const entry = target && target.closest('summary.header__icon--menu, a.header__heading-link, summary.header__icon--search');
        if (!entry || !entry.closest('header.header') || !this.active || !this.isConnected) return;
        const mode = this.mobile.matches ? 'mobile' : 'desktop';
        if (this.dataset[mode + 'Enabled'] !== 'true') return;
        let displayed = false;
        if (this.feedbackActive && this.status && this.claimRecord) {
          this.statusDismissed = false;
          this.claimRecord.dismissed = false;
          this.writeClaim(this.claimRecord);
          this.syncFeedbackVisibility();
          displayed = !this.status.hidden;
          if (displayed) this.scheduleSavings();
        } else if (this.eligible(true)) {
          // A deliberate header action is its own trigger; passive browsing gates stay unchanged.
          this.dataset.triggerReason = entry.matches('.header__heading-link') ? 'header-logo' : entry.matches('.header__icon--search') ? 'header-search' : 'header-menu';
          this.show(false);
          displayed = this.dialog.open;
        }
        // Fail open: never leave a dead menu/link if the offer could not be displayed.
        if (displayed) { event.preventDefault(); event.stopImmediatePropagation(); }
      }, { capture: true });
    }

    initializeIntent(on) {
      this.intentKey = 'glownest_exit_intent_v2';
      this.productIds = (this.dataset.productIds || '').split(',').filter(Boolean);
      this.intent = { at: Date.now(), products: {}, cartVisits: 0 };
      try {
        const saved = JSON.parse(sessionStorage.getItem(this.intentKey) || 'null');
        if (saved && saved.products && Date.now() - saved.at < 1800000 && saved.at <= Date.now()) this.intent = saved;
      } catch (_) { /* In-memory interest still works; no cross-page recovery. */ }
      const returnedId = this.intent.checkout && this.intent.checkout.productId;
      this.productId = this.dataset.context === 'product' ? this.productIds[0] :
        this.productIds.find(id => id === returnedId) ||
        this.productIds.find(id => this.intent.products[id] && !this.coolingDown(id)) ||
        this.productIds.find(id => this.intent.products[id]) || this.productIds[0] || 'storefront';
      const savedProduct = this.intent.products[this.productId] || {};
      this.interest = { quantity: false, added: false, images: [], readMs: 0, depth: 0, ...savedProduct };
      if (this.dataset.context !== 'product' && this.productIds.length) this.interest.added = true;
      this.intent.products[this.productId] = this.interest;
      this.visibleSince = document.hidden ? null : performance.now();
      this.visibleElapsed = 0;
      this.productRoot = this.dataset.context === 'product' ? document.querySelector('[id^="MainProduct-"]') : null;
      this.description = this.productRoot ? this.productRoot.querySelector('.product__description') : document.querySelector('main');
      this.gallery = this.productRoot && this.productRoot.querySelector('media-gallery');
      this.maxDepth = this.interest.depth || 0;
      this.updateDepth();
      const quantitySelector = '[data-mix-match-1xd] [data-plus], [data-mix-match-1xd] [data-minus], [data-mix-match-1xd] [data-panel-plus], [data-mix-match-1xd] [data-panel-minus], quantity-input button';
      on(document, 'click', event => {
        this.touchIntent();
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        if (this.productRoot && this.productRoot.contains(target) && target.closest(quantitySelector) && !target.closest('[disabled], [aria-disabled="true"]')) {
          this.interest.quantity = true; this.saveIntent();
        }
        if (this.isCheckoutAction(target)) {
          return;
        }
        if (target.closest('a[href]') && this.checkoutArmed) { this.checkoutArmed = false; delete this.intent.checkout; this.saveIntent(); }
        if (target.closest('cart-drawer .drawer__close, #CartDrawer-Overlay')) this.armDrawerClose();
      }, { capture: true });
      on(document, 'change', event => {
        this.touchIntent();
        if (this.productRoot && this.productRoot.contains(event.target) && event.target.matches('input[name="quantity"]') && Number(event.target.value) > 0) {
          this.interest.quantity = true; this.saveIntent();
        }
      });
      // Bubble after theme validation handlers; retain the event for the pagehide check.
      on(window, 'click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (target && this.isCheckoutAction(target) && !event.defaultPrevented && this.sameTabCheckout(event, target)) this.armCheckout(event);
      });
      on(window, 'submit', event => {
        if (!event.submitter || !this.isCheckoutAction(event.submitter)) return;
        this.checkoutEvent = event;
        if (!event.defaultPrevented && this.sameTabCheckout(event, event.submitter)) this.armCheckout(event);
        else if (this.checkoutArmed) { this.checkoutArmed = false; delete this.intent.checkout; this.saveIntent(); }
      });
      on(document, 'keydown', event => { if (event.key === 'Escape') this.armDrawerClose(); }, { capture: true });
      this.connectCartEvents();
      on(window, 'load', () => this.connectCartEvents());
      if (this.gallery) {
        this.recordImage(this.gallery.querySelector('.product__media-item.is-active'));
        const gesture = () => { this.touchIntent(); this.galleryGesture = performance.now(); this.recordImage(this.gallery.querySelector('.product__media-item.is-active')); };
        for (const name of ['pointerdown', 'touchstart', 'keydown', 'click']) on(this.gallery, name, gesture, { passive: true });
        const record = element => { if (performance.now() - this.galleryGesture < 2000) this.recordImage(element || this.gallery.querySelector('.product__media-item.is-active')); };
        on(this.gallery, 'slideChanged', event => record(event.detail && event.detail.currentElement), { capture: true });
        this.galleryObserver = new MutationObserver(() => record());
        this.galleryObserver.observe(this.gallery, { attributes: true, attributeFilter: ['class', 'aria-current'], subtree: true });
      }
      this.drawer = document.querySelector('cart-drawer');
      if (this.drawer) {
        this.drawerObserver = new MutationObserver(() => this.observeDrawer());
        this.drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['class', 'open'] });
        this.observeDrawer();
      }
      this.checkCheckoutReturn();
    }

    connectCartEvents() {
      if (this.unsubscribeCart || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
      this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
        if (!this.active || event.source !== 'product-form' || !event.cartData || event.cartData.status) return;
        const items = Array.isArray(event.cartData.items) ? event.cartData.items : [event.cartData];
        if (items.some(item => (this.dataset.context !== 'product' || String(item.product_id) === this.productId) && Number(item.quantity) > 0)) {
          this.touchIntent();
          this.interest.added = true; this.saveIntent();
        }
      });
    }

    saveIntent() {
      if (!this.intent) return;
      this.ensureFreshIntent();
      try { sessionStorage.setItem(this.intentKey, JSON.stringify(this.intent)); } catch (_) { /* Optional session persistence. */ }
    }

    ensureFreshIntent() {
      if (!this.intent || Date.now() - this.intent.at < 1800000 && this.intent.at <= Date.now()) return;
      this.interest = { quantity: false, added: false, images: [], readMs: 0, depth: 0 };
      this.intent = { at: Date.now(), products: { [this.productId]: this.interest }, cartVisits: 0 };
      this.maxDepth = 0;
      this.visibleElapsed = 0;
      this.visibleSince = document.hidden ? null : performance.now();
      this.checkoutArmed = false;
      this.drawerCloseIntent = null;
    }

    touchIntent() { if (this.intent && !document.hidden) { this.ensureFreshIntent(); this.intent.at = Date.now(); } }

    pauseReading() {
      if (this.visibleSince == null) return;
      const elapsed = Math.max(0, performance.now() - this.visibleSince);
      this.visibleElapsed += elapsed;
      if (this.interest) this.interest.readMs += elapsed;
      this.visibleSince = null;
      this.saveIntent();
    }

    resumeReading() { if (this.visibleSince == null && !document.hidden) this.visibleSince = performance.now(); }

    visibleTime() { return (this.visibleElapsed || 0) + (this.visibleSince == null ? 0 : Math.max(0, performance.now() - this.visibleSince)); }

    hasInterest() {
      this.ensureFreshIntent();
      if (!this.interest) return false;
      const readMs = this.interest.readMs + (this.visibleSince != null ? Math.max(0, performance.now() - this.visibleSince) : 0);
      return this.interest.quantity || this.interest.added || this.interest.images.length >= 2 ||
        readMs >= Number(this.dataset.readingSeconds) * 1000 && this.interest.depth >= Number(this.dataset.depth);
    }

    recordImage(element) {
      if (!element || !this.gallery.contains(element) || document.hidden) return;
      const item = element.closest('.product__media-item[data-media-id]');
      if (!item) return;
      const rect = item.getBoundingClientRect();
      if (rect.width <= 0 || rect.height <= 0 || rect.bottom <= 0 || rect.top >= innerHeight || rect.right <= 0 || rect.left >= innerWidth) return;
      const id = item.dataset.mediaId;
      if (!this.interest.images.includes(id)) { this.interest.images.push(id); this.saveIntent(); }
    }

    observeDrawer() {
      const open = this.drawer.classList.contains('active') || this.drawer.hasAttribute('open');
      if (open === this.drawerWasOpen) return;
      this.drawerWasOpen = open;
      if (open) {
        this.intent.cartVisits = (this.intent.cartVisits || 0) + 1;
        this.drawerCloseIntent = null;
        this.saveIntent();
      } else if (this.drawerCloseIntent != null && performance.now() - this.drawerCloseIntent < 1500 && !this.checkoutArmed) {
        this.drawerCloseIntent = null;
        this.ensureFreshIntent();
        this.interest.drawerCloses = (this.interest.drawerCloses || 0) + 1;
        this.saveIntent();
        clearTimeout(this.drawerCloseTimer);
        if (this.intent.cartVisits >= 1) this.drawerCloseTimer = setTimeout(() => this.requestShow('cart-close'), 500);
      }
    }

    armDrawerClose() {
      if (this.drawerWasOpen) this.drawerCloseIntent = performance.now();
    }

    isCheckoutAction(target) {
      if (target.closest('[name="checkout"]')) return true;
      const link = target.closest('a[href]');
      if (!link) return false;
      try { const url = new URL(link.href, location.href); return url.origin === location.origin && /\/(?:checkout|checkouts)(?:\/|$)/.test(url.pathname); } catch (_) { return false; }
    }

    sameTabCheckout(event, target) {
      if (event.button != null && event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return false;
      const link = target.closest('a[href]');
      const button = target.closest('button, input');
      const targetName = link ? link.target : button && (button.formTarget || button.form && button.form.target);
      return !targetName || targetName === '_self';
    }

    armCheckout(event) {
      if (!this.hasInterest()) return;
      this.checkoutArmed = true;
      this.checkoutEvent = event;
      this.drawerCloseIntent = null;
      this.intent.checkout = { at: Date.now(), productId: this.productId, left: false };
      this.saveIntent();
      clearTimeout(this.checkoutArmTimer);
      this.checkoutArmTimer = setTimeout(() => { this.checkoutArmed = false; if (this.intent.checkout && !this.intent.checkout.left) { delete this.intent.checkout; this.saveIntent(); } }, 10000);
    }

    async checkCheckoutReturn() {
      if (!this.intent || this.returnChecking || !this.active) return;
      const marker = this.intent.checkout;
      if (!marker || !marker.left || Date.now() - marker.at > 1800000 || (this.dataset.context === 'product' && !this.productIds.includes(marker.productId))) return;
      // A departed checkout link plus return is a heuristic, not checkout-page instrumentation.
      this.returnChecking = true;
      this.checkoutArmed = false;
      delete this.intent.checkout;
      this.saveIntent();
      this.returnRequest = new AbortController();
      const timeout = setTimeout(() => this.returnRequest.abort(), 8000);
      try {
        const root = (this.dataset.root || '/').replace(/\/?$/, '/');
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: this.returnRequest.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (Array.isArray(cart.items) && cart.items.some(item => (this.dataset.context !== 'product' || String(item.product_id) === marker.productId) && item.quantity > 0)) {
          this.interest.added = true; this.saveIntent();
          this.returnTimer = setTimeout(() => this.requestShow('checkout-return'), 600);
        }
      } catch (_) { /* No verified cart, no return offer. */ }
      finally { clearTimeout(timeout); this.returnChecking = false; }
    }

    readClaim() {
      for (const storageName of ['localStorage', 'sessionStorage']) {
        try {
          const record = JSON.parse(window[storageName].getItem(KEY + '_claim') || 'null');
          if (record && record.code === this.code && Number.isFinite(record.at) && record.at <= Date.now()) return record;
        } catch (_) {}
      }
      return null;
    }

    writeClaim(record) {
      for (const storageName of ['localStorage', 'sessionStorage']) {
        try { window[storageName].setItem(KEY + '_claim', JSON.stringify(record)); } catch (_) {}
      }
    }

    initializeFeedback(on) {
      this.status = this.querySelector('[data-offer-status]');
      if (!this.status) return;
      try {
        let claim = this.readClaim();
        if (!claim) {
          let at = 0;
          try { at = Number(localStorage.getItem(this.cooldownKey())); } catch (_) {}
          if (Number.isFinite(at) && at > 0 && at <= Date.now() && (Date.now() - at < Number(this.dataset.cooldown) * 86400000 || this.dataset.cartOffer === 'true')) claim = { code: this.code, at };
          else if (this.dataset.cartOffer === 'true') claim = { code: this.code, at: Date.now() - 300000 };
        }
        if (!claim) return;
        this.writeClaim(claim);
        this.claimRecord = claim;
        this.statusDismissed = claim.dismissed === true;
      } catch (_) { return; }
      this.feedbackActive = true;
      this.updateReminder();
      this.reminderTimer = setInterval(() => { if (!document.hidden) this.updateReminder(); }, 1000);
      on(document, 'visibilitychange', () => { if (!document.hidden) this.updateReminder(); });
      on(window, 'pageshow', () => this.updateReminder());
      on(this.querySelector('[data-status-close]'), 'click', () => {
        this.status.hidden = true; this.statusDismissed = true;
        this.claimRecord.dismissed = true;
        this.writeClaim(this.claimRecord);
      });
      on(this.querySelector('[data-status-cart]'), 'click', event => {
        if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return;
        const icon = document.querySelector('#cart-icon-bubble');
        const focusTarget = icon && icon.tagName === 'DIV' ? icon.closest('.header__icon--cart') : icon;
        // Use Shrine's own opening, scroll locking and focus handling.
        try { drawer.open(focusTarget || undefined); } catch (_) { return; }
        event.preventDefault();
        this.status.hidden = true;
        queueMicrotask(() => this.syncFeedbackVisibility());
      });
      on(window, 'focus', () => this.scheduleSavings());
      on(document, 'visibilitychange', () => { if (!document.hidden) this.scheduleSavings(); });
      for (const event of ['cart:updated', 'cart:refresh', 'cart:change']) on(document, event, () => this.scheduleSavings());
      // Observe theme cart rendering; never patch fetch, product forms or checkout.
      const cartSelector = 'cart-drawer, cart-notification, #cart-icon-bubble, #main-cart-items, #main-cart-footer';
      this.cartObserver = new MutationObserver(records => {
        this.syncFeedbackVisibility();
        if (records.some(record => {
          if (record.type !== 'childList') return false;
          const owner = record.target instanceof Element ? record.target : record.target.parentElement;
          if (owner && owner.closest('gn-exit-offer, gn-exit-offer-savings, countdown-timer, .cart-timer')) return false;
          const nodes = [...record.addedNodes, ...record.removedNodes];
          if (nodes.length && nodes.every(node => node instanceof Element && node.matches('gn-exit-offer-savings, countdown-timer, .cart-timer'))) return false;
          return owner && owner.closest(cartSelector) || nodes.some(node => node instanceof Element && (node.matches(cartSelector) || node.querySelector(cartSelector)));
        })) this.scheduleSavings();
      });
      this.cartObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'open'] });
      this.checkSavings();
    }

    scheduleSavings() {
      if (!this.feedbackActive || document.hidden) return;
      clearTimeout(this.savingsTimer);
      this.savingsTimer = setTimeout(() => this.checkSavings(), 350);
    }

    setStatus(state, title, detail, money = '') {
      if (!this.active || !this.status) return;
      this.status.dataset.state = state;
      this.querySelector('[data-status-title]').textContent = title;
      this.querySelector('[data-status-detail]').textContent = detail;
      this.feedback = { state, title, detail, money };
      this.syncCartSavings();
      this.syncFeedbackVisibility();
    }

    syncFeedbackVisibility() {
      if (!this.feedbackActive || !this.status) return;
      this.status.hidden = !!this.statusDismissed || !!document.querySelector('cart-drawer.active, cart-drawer[open]');
    }

    syncCartSavings() {
      if (!this.feedback) return;
      const drawer = document.querySelector('cart-drawer');
      const footer = document.querySelector('#main-cart-footer');
      const targets = [drawer && (drawer.querySelector('.drawer__footer') || drawer), footer && (footer.querySelector('.cart__footer') || footer)].filter(Boolean);
      this.savingsBanners = this.savingsBanners || new Set();
      for (const banner of this.savingsBanners) if (!banner.isConnected) this.savingsBanners.delete(banner);
      for (const target of targets) {
        let banner = target.querySelector('gn-exit-offer-savings');
        if (!banner) {
          banner = document.createElement('gn-exit-offer-savings');
          const title = document.createElement('strong');
          const detail = document.createElement('p');
          banner.append(title, detail);
          const note = document.createElement('small');
          note.setAttribute('data-savings-note', '');
          banner.append(note);
          const reminder = this.querySelector('[data-reminder]');
          if (reminder) banner.append(reminder.cloneNode(true));
          target.prepend(banner);
          this.savingsBanners.add(banner);
        }
        banner.dataset.state = this.feedback.state;
        const applied = this.feedback.state === 'applied';
        const title = this.code + ' · Extra ' + this.dataset.percentage + (applied ? '% off' : '% offer');
        const detail = applied ? '−' + this.feedback.money : (this.feedback.state === 'unavailable' && this.feedback.money ? 'Est. extra ' + this.feedback.money : (this.feedback.state === 'empty' ? 'Add items' : (this.feedback.state === 'checking' ? 'Checking…' : 'Check at checkout')));
        if (banner.querySelector('strong').textContent !== title) banner.querySelector('strong').textContent = title;
        if (banner.querySelector('p').textContent !== detail) banner.querySelector('p').textContent = detail;
        const note = applied ? 'Applied on top of your item discounts.' : (this.feedback.state === 'unavailable' ? 'Not yet included in subtotal. Confirm at checkout.' : 'Additional to eligible item discounts.');
        if (banner.querySelector('[data-savings-note]').textContent !== note) banner.querySelector('[data-savings-note]').textContent = note;
      }
      this.updateReminder();
    }

    updateReminder() {
      if (!this.claimRecord || !this.feedbackActive) return;
      const seconds = Math.max(0, Math.min(300, Math.ceil((this.claimRecord.at + 300000 - Date.now()) / 1000)));
      const time = String(Math.floor(seconds / 60)).padStart(2, '0') + ':' + String(seconds % 60).padStart(2, '0');
      const panels = [this.status, ...this.savingsBanners || []].filter(panel => panel && panel.isConnected);
      for (const panel of panels) {
        const timer = panel.querySelector('[data-reminder-time]');
        if (timer) timer.hidden = seconds === 0;
        const values = [
          ['[data-reminder-time]', time],
          ['[data-reminder-label]', seconds ? 'Complete your order' : (this.feedback && this.feedback.state === 'applied' ? 'Your savings are ready — checkout now' : 'Confirm your discount at checkout')]
        ];
        for (const [selector, text] of values) {
          const node = panel.querySelector(selector);
          if (node && node.textContent !== text) node.textContent = text;
        }
      }
      if (!seconds) clearInterval(this.reminderTimer);
    }

    async checkSavings() {
      if (!this.active || !this.feedbackActive) return;
      if (this.checkingSavings) { this.savingsDirty = true; return; }
      this.checkingSavings = true;
      if (!this.feedback) this.setStatus('checking', 'Checking your savings…', 'Confirming your offer with the store.');
      this.status.setAttribute('aria-busy', 'true');
      this.savingsRequest = new AbortController();
      const timeout = setTimeout(() => this.savingsRequest.abort(), 8000);
      try {
        const root = (this.dataset.root || '/').replace(/\/?$/, '/');
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }, signal: this.savingsRequest.signal });
        if (!response.ok) throw new Error('Cart unavailable');
        const cart = await response.json();
        if (!Number.isFinite(cart.item_count) || !Array.isArray(cart.cart_level_discount_applications)) throw new Error('Invalid cart');
        const discount = cart.cart_level_discount_applications.find(item => String(item.title).toUpperCase() === this.code.toUpperCase() && item.type === 'discount_code');
        const saved = discount && Number(discount.total_allocated_amount);
        const percent = Number(this.dataset.percentage);
        if (cart.item_count === 0) {
          this.setStatus('empty', 'Your offer is selected', 'Add items to your cart to check your ' + percent + '% savings. Savings are not applied yet.');
        } else if (saved > 0 && discount.value_type === 'percentage' && Number(discount.value) === percent) {
          const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency }).format(saved / 100);
          this.setStatus('applied', '🎉 ' + percent + '% OFF applied!', 'You save ' + money + ' with ' + this.code + ' on your current cart. This is in addition to any product discounts already applied.', money);
        } else {
          const subtotal = cart.items_subtotal_price;
          const estimate = Number.isFinite(subtotal) && subtotal > 0 && percent > 0 && percent <= 100
            ? new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cart.currency }).format(Math.round(subtotal * percent / 100) / 100) : '';
          this.setStatus('unavailable', 'Your ' + percent + '% offer is not applied yet', (estimate ? 'Estimated extra savings: ' + estimate + '. ' : '') + 'Check ' + this.code + ' at checkout before paying. Your current items or other discounts may affect eligibility.', estimate);
        }
      } catch (_) {
        this.setStatus('error', 'We couldn’t verify your savings', 'Please view your cart and check your discount at checkout before paying.');
      } finally {
        clearTimeout(timeout);
        this.checkingSavings = false;
        this.status.setAttribute('aria-busy', 'false');
        if (this.savingsDirty) { this.savingsDirty = false; this.scheduleSavings(); }
      }
    }

    onTouch(event) {
      const point = event.touches && event.touches[0];
      if (event.type === 'touchcancel' || event.touches.length > 1 || event.target.closest('a, button, input, select, textarea, [contenteditable], [role="button"]')) {
        this.touchPoint = null;
        this.lastTouch = -Infinity;
        return;
      }
      if (event.type === 'touchstart') {
        this.touchPoint = point ? { id: point.identifier, x: point.clientX, y: point.clientY } : null;
        this.fingerDownDistance = 0;
        this.fingerSideDistance = 0;
        this.lastTouch = -Infinity;
        this.resetGesture();
        return;
      }
      if (event.type === 'touchend') {
        // Only a previously directional swipe can authorize its inertial scrolling.
        if (Number.isFinite(this.lastTouch)) this.lastTouch = performance.now();
        this.touchPoint = null;
        return;
      }
      if (!point || !this.touchPoint || point.identifier !== this.touchPoint.id) return;
      const dy = point.clientY - this.touchPoint.y, dx = point.clientX - this.touchPoint.x;
      this.touchPoint = { id: point.identifier, x: point.clientX, y: point.clientY };
      if (dy < 0) {
        this.fingerDownDistance = 0;
        this.fingerSideDistance = 0;
        this.lastTouch = -Infinity;
        return;
      }
      this.fingerDownDistance += dy;
      this.fingerSideDistance += Math.abs(dx);
      // Finger down means page up. A stationary tap or horizontal swipe is insufficient.
      if (this.fingerDownDistance >= 60 && this.fingerDownDistance > this.fingerSideDistance * 1.5) this.lastTouch = performance.now();
    }

    resetGesture() {
      this.lastY = Math.max(0, window.scrollY);
      this.lastHeight = window.innerHeight;
      this.samples = [{ y: this.lastY, at: performance.now() }];
    }

    updateDepth() {
      if (!this.description || !this.interest || document.hidden) return;
      const rect = this.description.getBoundingClientRect();
      if (rect.height <= 0 || rect.top >= innerHeight || rect.bottom <= 0) return;
      this.maxDepth = Math.max(this.maxDepth, Math.min(100, Math.max(0, innerHeight - rect.top) / rect.height * 100));
      this.interest.depth = this.maxDepth;
    }

    onScroll() {
      if (this.claimed || this.feedbackActive || this.dialog.open) return;
      this.touchIntent();
      this.updateDepth();
      const now = performance.now(), y = window.scrollY;
      if (this.rapidNeedsBrowse) {
        this.rapidRearmY = Math.min(this.rapidRearmY, y);
        if (y - this.rapidRearmY >= 400) this.rapidNeedsBrowse = false;
      }
      const range = document.documentElement.scrollHeight - window.innerHeight;
      if (now - this.lastTouch > 1000 || y < 0 || y > range || this.lastHeight !== window.innerHeight) {
        this.resetGesture();
        return;
      }
      const delta = y - this.lastY;
      this.lastY = y;
      if (delta > 0) { this.samples = [{ y, at: now }]; return; }
      if (delta === 0) return;
      this.samples = this.samples.filter(sample => now - sample.at <= 700);
      this.samples.push({ y, at: now });
      if (this.samples[0].y - y > 350 && this.interest && this.interest.added) this.requestShow('rapid-return');
    }

    cooldownKey(productId = this.productId) {
      return KEY + '_claimed_product_' + productId;
    }

    coolingDown(productId = this.productId) {
      if (!productId) return true;
      try {
        const stamp = Number(localStorage.getItem(this.cooldownKey(productId)));
        return Number.isFinite(stamp) && stamp > 0 && Date.now() - stamp < Number(this.dataset.cooldown) * 86400000;
      } catch (_) {
        // Suppress when persistence is unavailable; never repeatedly nag a visitor.
        return true;
      }
    }

    eligible(headerAction = false) {
      if (!this.active || !this.isConnected || this.dialog.open || this.claimed || this.feedbackActive || document.visibilityState !== 'visible') return false;
      const mode = this.mobile.matches ? 'mobile' : 'desktop';
      if (this.dataset[mode + 'Enabled'] !== 'true') return false;
      if ((!headerAction && !this.hasInterest()) || this.coolingDown()) return false;
      const overlays = document.querySelectorAll('dialog[open], modal-dialog[open], product-modal[open], cart-drawer.active, cart-drawer[open], cart-notification.active, .popup-overlay--active, .popup-modal--active, [aria-modal="true"]:not([hidden]):not([aria-hidden="true"])');
      if ([...overlays].some(overlay => this.isVisibleOverlay(overlay))) return false;
      if (document.querySelector('cart-drawer.active, cart-drawer[open], cart-notification.active, .popup-overlay--active, .popup-modal--active')) return false;
      const bodyStyle = getComputedStyle(document.body);
      return !document.body.classList.contains('overflow-hidden') && bodyStyle.position !== 'fixed' && bodyStyle.overflowY !== 'hidden';
    }

    isVisibleOverlay(overlay) {
      if (overlay === this.dialog || !overlay.getClientRects().length) return false;
      // Shrine keeps its closed search dialog in the layout with opacity: 0.
      // Closed details, hidden/inert ancestors and off-screen drawers are not open modals.
      if (overlay.closest('details:not([open]), [hidden], [inert], [aria-hidden="true"]')) return false;
      for (let node = overlay; node; node = node.parentElement) {
        const style = getComputedStyle(node);
        if (style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
      }
      const rect = overlay.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.right > 0 && rect.top < window.innerHeight && rect.left < window.innerWidth;
    }

    requestShow(reason) {
      if (this.dataset.context === 'cart') {
        if (this.scopeChecking || !this.eligible()) return;
        this.checkCartScope(reason);
        return;
      }
      this.requestVerifiedShow(reason);
    }

    async checkCartScope(reason) {
      this.scopeChecking = true;
      this.scopeRequest = new AbortController();
      const timeout = setTimeout(() => this.scopeRequest.abort(), 8000);
      try {
        const root = (this.dataset.root || '/').replace(/\/?$/, '/');
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', signal: this.scopeRequest.signal });
        if (!response.ok) return;
        const cart = await response.json();
        if (Array.isArray(cart.items) && cart.items.some(item => (this.dataset.context !== 'product' || String(item.product_id) === this.productId) && item.quantity > 0)) this.requestVerifiedShow(reason);
      } catch (_) { /* Fail closed if the eligible cart item cannot be verified. */ }
      finally { clearTimeout(timeout); this.scopeChecking = false; }
    }

    requestVerifiedShow(reason) {
      if (this.pending || !this.eligible()) return;
      if (reason === 'rapid-return' && (!(this.interest && this.interest.drawerCloses >= 1) || this.rapidNeedsBrowse || Date.now() < (this.rapidBlockedUntil || 0))) return;
      const display = () => { if (this.eligible()) { this.dataset.triggerReason = reason || ''; this.show(false); } };
      // Serialize simultaneous eligible tabs where Web Locks is supported.
      if (navigator.locks && navigator.locks.request) {
        this.pending = true;
        navigator.locks.request(this.cooldownKey(), { ifAvailable: true }, lock => { if (lock) display(); })
          .catch(() => {})
          .finally(() => { this.pending = false; });
      } else display();
    }

    updateLink() {
      let pathname = window.location.pathname;
      try { pathname = decodeURI(pathname); } catch (_) {}
      const redirect = pathname + window.location.search + window.location.hash;
      this.claim.href = '/discount/' + encodeURIComponent(this.code) + '?redirect=' + encodeURIComponent(redirect);
    }

    show(preview) {
      if (this.dialog.open || !this.isConnected) return;
      this.previousFocus = document.activeElement;
      const position = { x: window.scrollX, y: window.scrollY };
      this.updateLink();
      try { this.dialog.showModal(); } catch (_) { return; }
      if (!this.dialog.open) return;
      this.shown = true;
      this.lockPage(position);
      this.claim.focus({ preventScroll: true });
    }

    outsidePanel(event) {
      const rect = this.dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    }

    lockPage(position) {
      const body = document.body;
      const gutter = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
      const changes = { position: 'fixed', top: -position.y + 'px', left: -position.x + 'px', right: '0px', width: '100%', overflow: 'hidden', 'box-sizing': 'border-box', 'padding-right': padding + gutter + 'px' };
      this.scrollLock = { position, saved: Object.entries(changes).map(([property, value]) => {
        const oldValue = body.style.getPropertyValue(property), priority = body.style.getPropertyPriority(property);
        body.style.setProperty(property, value);
        return { property, value, oldValue, priority };
      }) };
    }

    restorePage() {
      if (!this.scrollLock) return;
      const lock = this.scrollLock;
      this.scrollLock = null;
      for (const item of lock.saved) {
        if (document.body.style.getPropertyValue(item.property) !== item.value) continue;
        if (item.oldValue) document.body.style.setProperty(item.property, item.oldValue, item.priority);
        else document.body.style.removeProperty(item.property);
      }
      const root = document.documentElement;
      const behavior = root.style.getPropertyValue('scroll-behavior'), priority = root.style.getPropertyPriority('scroll-behavior');
      root.style.setProperty('scroll-behavior', 'auto', 'important');
      window.scrollTo(lock.position.x, lock.position.y);
      if (behavior) root.style.setProperty('scroll-behavior', behavior, priority);
      else root.style.removeProperty('scroll-behavior');
      if (this.previousFocus && this.previousFocus.isConnected) this.previousFocus.focus({ preventScroll: true });
    }

    close() {
      const closedRapid = this.dialog && this.dialog.open && this.dataset.triggerReason === 'rapid-return' && !this.editor;
      if (this.dialog && this.dialog.open) this.dialog.close();
      this.restorePage();
      if (closedRapid) {
        this.rapidBlockedUntil = Date.now() + 60000;
        this.rapidNeedsBrowse = true;
        this.rapidRearmY = Math.max(0, window.scrollY);
      }
      this.shown = false;
      this.lastTouch = -Infinity;
      this.touchPoint = null;
      this.fingerDownDistance = 0;
      this.fingerSideDistance = 0;
      this.resetGesture();
      clearTimeout(this.drawerCloseTimer);
      clearTimeout(this.returnTimer);
    }

    dispose() {
      this.pauseReading();
      this.close();
      if (this.unsubscribeCart) { this.unsubscribeCart(); this.unsubscribeCart = null; }
      if (this.galleryObserver) this.galleryObserver.disconnect();
      if (this.drawerObserver) this.drawerObserver.disconnect();
      clearTimeout(this.drawerCloseTimer);
      clearTimeout(this.checkoutArmTimer);
      clearTimeout(this.returnTimer);
      if (this.returnRequest) this.returnRequest.abort();
      if (this.scopeRequest) this.scopeRequest.abort();
      this.feedbackActive = false;
      clearInterval(this.reminderTimer);
      clearTimeout(this.savingsTimer);
      if (this.cartObserver) this.cartObserver.disconnect();
      if (this.savingsBanners) { for (const banner of this.savingsBanners) banner.remove(); this.savingsBanners.clear(); }
      if (this.savingsRequest) this.savingsRequest.abort();
      if (this.controller) this.controller.abort();
      this.active = false;
    }
  }
  customElements.define(TAG, GlowNestExitOffer);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
